import ReadWriteRecipientViewState from 'owa-recipient-types/lib/types/ReadWriteRecipientViewState';
import { action } from 'satcheljs/lib/legacy';
export default action('updateIsEditing')(function updateEditedRecipient(
    oldRecipient: ReadWriteRecipientViewState,
    newRecipient: ReadWriteRecipientViewState
) {
    oldRecipient.persona = newRecipient.persona;
    oldRecipient.displayText = newRecipient.displayText;
    oldRecipient.isValid = newRecipient.isValid;
    oldRecipient.isEditing = false;
});
